import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';

function DocumentClaimsHitComponent({ claimsText, closeClick, trackingAttrs }) {
  const claimsHit = DocumentHitsFormat.checkAndFormatHit(claimsText, 'claims');

  return claimsHit ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      {...trackingAttrs}
      className="result-detail-panel result-detail-claims-hit document-hit e2e-document-action-claims-hit"
      onClick={closeClick}
      role="button"
      tabIndex="0"
      aria-label="Claims hit">
      <div className="result-detail-panel-wrapper">
        <h4>Claims hit:</h4>
        <InnerHTML tag="div" className="result-detail-block typography-small" html={claimsHit} />
        <svg className="els-btn-icon svg-icon els-btn-icon-sm">
          <use xlinkHref="#icon-chevron-down" />
        </svg>
      </div>
    </div>
  ) : null;
}

DocumentClaimsHitComponent.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentClaimsHitComponent;
